import { render, staticRenderFns } from "./UserMemberCard.vue?vue&type=template&id=58ddc2fa&scoped=true&"
import script from "./UserMemberCard.vue?vue&type=script&lang=js&"
export * from "./UserMemberCard.vue?vue&type=script&lang=js&"
import style0 from "./UserMemberCard.vue?vue&type=style&index=0&id=58ddc2fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ddc2fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
